import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import Accordion from 'components/shared/generic/accordion/presentational/Accordion';
import { getTheme } from '../../../../../selectors/darkMode';
import clsx from 'clsx';
import { ZendeskArticle } from 'lib/type';

interface ZendeskFAQsProps {
    faqs?: ZendeskArticle[];
}

const ZendeskFAQs: FC<ZendeskFAQsProps> = ({ faqs }) => {
    const isDarkModeEnabled = useSelector(getTheme);

    return (
        <div
            data-testid="zendesk-faqs-container"
            className={clsx('zendesk-faqs', {
                'dark-mode': isDarkModeEnabled,
            })}
        >
            {faqs?.map(({ title, body, id }) => (
                <Accordion key={id} title={title} tracking>
                    <div dangerouslySetInnerHTML={{ __html: body }} />
                </Accordion>
            ))}
        </div>
    );
};

export default ZendeskFAQs;
